import { ApolloClient, from, InMemoryCache, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { RetryLink } from '@apollo/client/link/retry';
import { createClient } from 'graphql-ws';
import { HttpLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import URL from '../helper';
import { getTrackingAccessToken } from '../services/authAPI';
let statusCodeCallback;
const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const setStatusCodeCallback = callback => {
  statusCodeCallback = callback;
};

const httpLink = new HttpLink({
  uri: URL.APOLLO_HTTP_URL,
});

const retryLink = new RetryLink({
  delay: (count, operation, error) => {
    return count * 2000;
  },
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: URL.APOLLO_SOCKET_URL,
    connectionParams: async () => {
      const res = await getTrackingAccessToken();
      statusCodeCallback && statusCodeCallback(res.statusCode);
      if (res.statusCode === 4002) {
        return { token: res?.data || '', timeZone: localTimeZone };
      } else {
        return { token: '', timeZone: localTimeZone };
      }
    },
    options: {
      reconnect: true,
    },
  }),
);

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpLink,
);

const client = new ApolloClient({
  link: from([retryLink, link]),
  cache: new InMemoryCache(),
});

export default client;
